<script lang="ts" setup>
import { CfgButton, CfgDialog, CfgModalSizes, CfgTypography, CfgTypographySizes } from '@cfgtech/ui';
import { InfoCircleIcon } from '@cfgtech/icons';
const isOpened = defineModel<boolean>('isOpened', { default: false });

const route = useRoute();

const router = useRouter();

const responsive = useResponsive();

const closeDialog = () => {
  isOpened.value = false;
  const { rebrandingAnnouncement, ...query } = route.query;
  router.replace({ query });
};
</script>

<template>
  <CfgDialog
    v-model:opened="isOpened"
    :is-full-screen="responsive.mobile"
    :size="CfgModalSizes.Medium"
    title="Vstupujeme do další fáze!"
  >
    <div class="space-y-4 pt-4">
      <CfgTypography :size="CfgTypographySizes.md" tag-name="p">
        Děkujeme vám za vaši účast v <strong>beta verzi</strong> naší aplikace. Vaše zapojení je pro nás nepostradatelné při vývoji produktu.
      </CfgTypography>

      <CfgTypography :size="CfgTypographySizes.md" tag-name="p">
        S radostí vám oznamujeme, že <strong>Dluhopisová peněženka nově spadá pod</strong>

        naší existující službu <strong>Srovnávač dluhopisů</strong>.
      </CfgTypography>

      <!-- logos -->

      <img class="!my-10 mx-auto w-full max-w-sm" src="/logo-change.svg">

      <CfgTypography :size="CfgTypographySizes.md" tag-name="p">
        Nebojte se, <strong>vaše data a nastavení zůstávají nedotčena</strong>. Mění se pouze vzhled a doména.
      </CfgTypography>

      <CfgTypography :size="CfgTypographySizes.md" tag-name="p">
        Ještě jednou děkujeme za vaši podporu a těšíme se na další společnou cestu!
      </CfgTypography>

      <CfgButton class="!mt-10 w-full" @click="closeDialog">
        Zavřít zprávu
      </CfgButton>

      <div class="mt-8 flex items-stretch space-x-3 text-secondary">
        <div class="mt-[3px]">
          <InfoCircleIcon class="text-[20px]" />
        </div>

        <CfgTypography :size="CfgTypographySizes.sm" tag-name="p">
          Pokud máte jakékoliv dotazy, neváhejte se na nás obrátit na čísle +420 <strong>779 998 269</strong>
        </CfgTypography>
      </div>
    </div>
  </CfgDialog>
</template>
